module.exports = __webpack_public_path__ + "img/Z85-X18-中_06.ea745fbb.jpg";